// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1h-aN","col":"styles_col__3PlDN","fulfillmentStatus":"styles_fulfillmentStatus__2iTs2","emailCol":"styles_emailCol__3tf77"};